import { AppBrandingService, WINDOW } from '@eucoms/common-components';
import { Component, Inject } from '@angular/core';

import copy from './copy';
import { constants } from '@app/constants';

/**
 * this class provides the top banner above the navigation, which includes a
 * CTA to Current Outages
 */
@Component({
  selector: 'app-outages-notice',
  templateUrl: './outages-notice.component.html',
  styleUrls: ['./outages-notice.component.scss']
})
export class OutagesNoticeComponent {
  copyTitle = copy.title;
  copyCaption = copy.caption;
  copyCTA = copy.CTA;

  get opCoColor() {
    return this.appBranding.theme['--primaryBrand'];
  }

  constructor(
    private appBranding: AppBrandingService,
    @Inject(WINDOW) private window: Window
  ) { }

  onClickCTA() {
    // console.log('onClickCTA');
    this.window.open(constants.checkOutageStatusUrl, '_top');
  }
}
